import { render, staticRenderFns } from "./ResourceStats.vue?vue&type=template&id=c10e116c&"
import script from "./ResourceStats.vue?vue&type=script&lang=js&"
export * from "./ResourceStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports